<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
          v-if="actor.privilege <= 3"
        >
          <label class="vs-input--label">Select User</label>
          <v-select
            :options="searchList"
            @search="getUsers"
            placeholder="Search..."
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="keyword"
            class="mb-3"
          >
            <template #no-options>{{ noOptionText }}</template>
          </v-select>
        </div>

        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">Select Month</label>
          <flat-pickr
            class="fp"
            :config="config"
            style="width: 100%"
            v-model="filter.month"
          />
        </div>

        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mt-2">
          <vs-button
            :disabled="loading"
            id="searchBtn"
            style="width: 100%"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="pl-5 mt-1 vs-con-loading__container"
            @click="search"
            >Search</vs-button
          >
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            v-if="data.length > 0"
            id="exportBtn"
            icon-pack="feather"
            icon="icon-file-text"
            color="success"
            type="gradient"
            class="mb-4 md:mb-0 vs-con-loading__container"
            @click="handleDownload"
            >Export Data</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(250)">
              <span>250</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(500)">
              <span>500</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <div class="table-container">
        <el-table
          :data="data"
          :sort-by="sort_by"
          border
          :height="data.length > 0 ? 1200 : 135"
          style="
            width: 100%;
            margin-top: 10px;
            margin-bottom: 10px;
            border-left: 1px solid #ccc;
          "
        >
          <el-table-column
            label="No"
            width="68"
            type="index"
            :index="indexMethod"
          >
          </el-table-column>
          <el-table-column prop="imei" label="Imei" sortable width="160">
          </el-table-column>
          <el-table-column prop="plate" label="Plate" sortable width="150">
          </el-table-column>
          <el-table-column
            prop="device_name"
            label="Device Name"
            sortable
            width="245"
          >
          </el-table-column>
          <el-table-column
            prop="driver_name"
            label="Driver Name"
            sortable
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="start_point"
            label="Starting Points"
            sortable
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="violation_point"
            label="Violation Points"
            sortable
            width="170"
          >
          </el-table-column>
          <el-table-column
            prop="remaining_point"
            label="Remaining Points"
            sortable
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="driver_category"
            label="Driver Category"
            sortable
            width="170"
          >
            <template slot-scope="scope">
              <span
                :style="`color:${scope.row.legend_color};font-weight:600;`"
                >{{ scope.row.driver_category }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="month" label="Month" sortable width="150">
          </el-table-column>
          <el-table-column
            prop="year"
            label="Year"
            sortable
            width="150"
          ></el-table-column>

          <el-table-column label="Action" fixed="right">
            <template slot-scope="scope">
              <div class="flex">
                <vx-tooltip text="Violation Details" position="top">
                  <vs-button
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-list"
                    color="primary"
                    class="mr-2 vs-con-loading__container"
                    @click="detail(scope.row)"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip text="Violation Chart" position="top">
                  <vs-button
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-bar-chart-2"
                    color="warning"
                    class="mr-2 vs-con-loading__container"
                    @click="chart(scope.row)"
                  ></vs-button>
                </vx-tooltip>
              </div>
            </template>
          </el-table-column>

          <div
            slot="append"
            v-if="data.length < 1 || loading"
            class="table_empty"
          >
            {{ loading ? 'Loading....' : 'No Data Available' }}
          </div>
        </el-table>
        <vs-pagination :total="n_page" v-model="page" goto></vs-pagination>
      </div>
    </div>

    <vs-popup
      class="vs-popup-lg"
      classContent="popup-example"
      :title="popupTitle"
      :active.sync="showPopup"
    >
      <template>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <div class="flex flex-wrap items-center">
              <div class="flex-grow">
                <vs-button
                  v-if="data.length > 0"
                  id="exportBtnDetail"
                  icon-pack="feather"
                  icon="icon-file-text"
                  color="success"
                  type="gradient"
                  class="mb-4 md:mb-0 vs-con-loading__container"
                  @click="handleDownloadDetail"
                  >Export Data</vs-button
                >
              </div>
              <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2"
                    >{{ page_detail * per_page_detail - (per_page_detail - 1) }}
                    -
                    {{
                      row_total_detail - page_detail * per_page_detail > 0
                        ? page_detail * per_page_detail
                        : row_total_detail
                    }}
                    of {{ row_total_detail }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="updatePerPageDetail(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPageDetail(25)">
                    <span>25</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPageDetail(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPageDetail(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPageDetail(250)">
                    <span>250</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPageDetail(500)">
                    <span>500</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>

            <div style="display: block; overflow-x: auto; white-space: nowrap">
              <table class="table" style="width: 100%">
                <thead>
                  <tr>
                    <th style="width: 4%">No</th>
                    <th>Alert Name</th>
                    <th>Point</th>
                    <th>Time</th>
                    <th>Lon</th>
                    <th>Lat</th>
                  </tr>
                </thead>
                <tbody v-if="loading_detail">
                  <tr>
                    <td colspan="10" class="text-center">Loading....</td>
                  </tr>
                </tbody>
                <tbody v-else-if="data_detail.length > 0">
                  <tr v-for="(item, index) in data_detail" :key="index">
                    <td>{{ item.no }}</td>
                    <td>{{ item.alert_name }}</td>
                    <td>{{ item.point }}</td>
                    <td>{{ item.time }}</td>
                    <td>{{ item.lon }}</td>
                    <td>{{ item.lat }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="10" class="text-center">No Data Available</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <vs-pagination
              :total="n_page_detail"
              v-model="page_detail"
              goto
            ></vs-pagination>
          </div>
        </div>
        <div class="vx-row mb-5"></div>
      </template>
    </vs-popup>

    <vs-popup
      class="vs-popup-lg"
      classContent="popup-example"
      :title="popupTitleChart"
      :active.sync="showPopupChart"
    >
      <template>
        <div class="vx-col w-full mb-base">
          <vx-card title="">
            <vue-apex-charts
              type="bar"
              height="350"
              :options="lineChartSimple.chartOptions"
              :series="lineChartSimple.series"
            ></vue-apex-charts>
            <template slot="codeContainer"> </template>
          </vx-card>
        </div>
      </template>
    </vs-popup>
  </div>
</template>

<style>
[dir='ltr'] .el-table .cell {
  padding-left: 10px;
  padding-right: 10px;
}

.el-table thead {
  color: #ffff;
  font-weight: bold;
}

[dir] .el-table--border::after,
[dir] .el-table--group::after,
[dir] .el-table::before {
  background-color: #ccc;
}

[dir] .el-table th.el-table__cell {
  background-color: #eee;
  font-size: 14px;
  color: #626262;
}

[dir] .el-table tr:active .el-table__cell {
  background-color: rgb(198, 198, 198);
}

[dir] .el-table td.el-table__cell,
[dir] .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #ccc;
}

[dir] .el-table .ascending .sort-caret.ascending {
  border-bottom-color: #ffff;
}

[dir] .el-table .descending .sort-caret.descending {
  border-top-color: #ffff;
}

.el-table--border .el-table__cell,
[dir='ltr']
  .el-table__body-wrapper
  .el-table--border.is-scrolling-left
  ~ .el-table__fixed {
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
}

[dir] .el-table .el-table__cell {
  padding: 7px 0;
}

.el-table__empty-block {
  display: none !important;
}

.table_empty {
  text-align: center;
  font-size: 13px;
  padding: 10px;
  border-left: 1px solid #ccc;
}

.table_total {
  padding: 10px;
  border-left: 1px solid #ccc;
}
</style>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

import VueApexCharts from 'vue-apexcharts'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'

export default {
  components: {
    flatPickr,
    vSelect,
    VueApexCharts
  },

  data() {
    return {
      lineChartSimple: {
        series: [],
        chartOptions: {
          noData: {
            text: 'No Data'
          },
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          plotOptions: {
            bar: {
              barHeight: '100%',
              distributed: true,
              horizontal: true,
              dataLabels: {
                position: 'bottom'
              }
            }
          },
          colors: [
            '#33b2df',
            '#2b908f',
            '#13d8aa',
            '#546E7A',
            '#d4526e',
            '#A5978B',
            '#f9a3a4',
            '#90ee7e',
            '#f48024',
            '#69d2e7'
          ],
          dataLabels: {
            enabled: true,
            textAnchor: 'start',
            style: {
              colors: ['#fff']
            },
            formatter: function (val, opt) {
              return opt.w.globals.labels[opt.dataPointIndex] + ':  ' + val
            },
            offsetX: 0,
            dropShadow: {
              enabled: true
            }
          },
          stroke: {
            width: 1,
            colors: ['#fff']
          },
          title: {
            text: 'Violation Chart',
            align: 'center',
            floating: true
          },
          subtitle: {
            text: 'Category Names as DataLabels inside bars',
            align: 'center'
          },
          xaxis: {
            categories: []
          },
          yaxis: {
            labels: {
              show: false
            }
          }
        }
      },

      data: [],
      token: '',
      action: '',
      loading: false,
      actor: '',
      tempId: 0,

      filter: {
        month: ''
      },

      filtered: {
        month: ''
      },

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',
      drivingScoreList: [],

      temp_detail: [],
      data_detail: [],
      page_detail: 1,
      per_page_detail: 10,
      row_total_detail: 0,
      loading_detail: false,

      data_chart: [],

      popupTitle: '',
      showPopup: false,

      popupTitleChart: '',
      showPopupChart: false,

      sort_by:
        ({ prop: 'imei', order: 'descending' },
        { prop: 'plate', order: 'descending' },
        { prop: 'device_name', order: 'descending' },
        { prop: 'driver_name', order: 'descending' },
        { prop: 'start_point', order: 'descending' },
        { prop: 'violation_point', order: 'descending' },
        { prop: 'remaining_point', order: 'descending' },
        { prop: 'grade', order: 'descending' },
        { prop: 'driver_category', order: 'descending' },
        { prop: 'month', order: 'descending' },
        { prop: 'year', order: 'descending' }),

      timer: null,
      notify: 'Server Error',

      searchList: [],
      searchListDefault: '',

      config: {
        dateFormat: 'M Y',
        // maxDate: this.maxDate,
        monthSelectorType: 'dropdown',
        plugins: [
          new monthSelectPlugin({
            shorthand: true,
            dateFormat: 'm-Y' //defaults to "F Y"
            // theme: "dark" // defaults to "light"
          })
        ]
      },

      filename: 'Driving Behavior Report',
      filenameDetail: 'Violation Detail',
      autoWidth: true,
      bookType: 'xlsx'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    n_page_detail() {
      return Math.ceil(this.row_total_detail / this.per_page_detail)
    },

    noOptionText() {
      return this.keyword ? 'Type to search' : 'No data found'
    },

    keyword_selected() {
      return this.keyword
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    page_detail() {
      this.getDetailData()
    },

    per_page_detail() {
      if (this.page_detail != 1) this.page_detail = 1
      else this.getDetailData()
    },

    keyword_selected() {
      this.getDrivingScore(this.keyword.value)
    },

    temp_detail: {
      handler(val) {
        if (val) {
          this.page_detail = 1
          this.getDetailData()
        }
      },
      deep: true
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        if (this.actor.privilege >= 4) this.getDrivingScore()
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {},

  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.per_page + (index + 1)
    },

    updatePerPage(n) {
      this.per_page = n
    },

    updatePerPageDetail(n) {
      this.per_page_detail = n
    },

    initTable() {
      this.loading = true

      this.$http
        .get(`${this.$api.endpoint}/report/driving_behavior2`, {
          params: {
            page: this.page,
            per_page: this.per_page,
            month: this.filter.month ? this.filter.month : '',
            keyword: this.keyword ? this.keyword.value : ''
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loading = false
          this.row_total = res.data.message.total
          this.data = res.data.message.data

          this.data.map((item, index) => {
            this.data[index].no = (this.page - 1) * this.per_page + (index + 1)
            this.data[index].plate = item._gps.plate
            this.data[index].device_name = item._gps.device_name
            this.data[index].remaining_point =
              item.start_point - item.violation_point

            let temp_score = this.drivingScoreList.find((e) => {
              return (
                item.remaining_point >= e.min_score &&
                item.remaining_point <= e.max_score
              )
            })

            if (!temp_score)
              temp_score = this.drivingScoreList.find((e) => {
                return e.grade == 3
              })

            this.data[index].grade = temp_score ? temp_score.grade : ''
            this.data[index].driver_category = temp_score
              ? temp_score.legend
              : ''
            this.data[index].legend_color = temp_score
              ? temp_score.legend_color
              : ''
          })

          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
        })
        .catch((error) => {
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    getDrivingScore(user_id = '') {
      let params = {}

      if (this.actor.privilege <= 3) {
        params = {
          keyword: user_id
        }
      }

      this.$http
        .get(`${this.$api.endpoint}/driving_scoring/list2`, {
          params,
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.drivingScoreList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    detail(data) {
      this.popupTitle = `Plate : ${data.plate} - Driver Name : ${data.driver_name}`
      this.showPopup = true
      this.temp_detail = data
    },

    getDetailData() {
      let params = {
        imei: this.temp_detail.imei,
        driver_name: this.temp_detail.driver_name,
        month: this.filter.month ? this.filter.month : '',
        page: this.page_detail,
        per_page: this.per_page_detail
      }

      this.$http
        .get(`${this.$api.endpoint}/report/driving_behavior2/detail`, {
          params,
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.data_detail = res.data.message.data
          this.row_total_detail = res.data.message.total

          this.data_detail.map((item, index) => {
            this.data_detail[index].no =
              (this.page_detail - 1) * this.per_page_detail + (index + 1)
          })
        })
        .catch((error) => {
          this.data_detail = []
          this.row_total_detail = 0
          this.$gf.httpErrorHandler(error)
        })
    },

    chart(data) {
      this.popupTitleChart = `Plate : ${data.plate} - Driver Name : ${data.driver_name}`
      this.showPopupChart = true

      this.lineChartSimple.chartOptions = {
        ...this.lineChartSimple.chartOptions,
        ...{
          noData: {
            text: 'Loading....'
          }
        }
      }

      let params = {
        imei: data.imei,
        driver_name: data.driver_name,
        month: this.filter.month ? this.filter.month : ''
      }

      this.$http
        .get(`${this.$api.endpoint}/report/driving_behavior2/chart`, {
          params,
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.data_chart = res.data.message.data

          this.lineChartSimple.chartOptions = {
            ...this.lineChartSimple.chartOptions,
            ...{
              noData: {
                text: 'No Data'
              }
            }
          }

          this.lineChartSimple.chartOptions = {
            ...this.lineChartSimple.chartOptions,
            ...{
              xaxis: {
                categories: this.data_chart.categories
              }
            }
          }

          this.lineChartSimple.series = this.data_chart.series
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)

          this.lineChartSimple.chartOptions = {
            ...this.lineChartSimple.chartOptions,
            ...{
              noData: {
                text: 'No Data'
              }
            }
          }
          this.lineChartSimple.chartOptions = {
            ...this.lineChartSimple.chartOptions,
            ...{
              xaxis: {
                categories: []
              }
            }
          }

          this.lineChartSimple.series = []
        })
    },

    getUsers(search) {
      // console.log(search.length)
      if (search.length >= 3) {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }

        this.timer = setTimeout(() => {
          this.$http
            .get(
              `${this.$api.endpoint}/tracking/search?keyword=${search}&type=user`,
              {
                headers: {
                  Authorization: `Bearer ${this.token}`
                }
              }
            )
            .then((res) => {
              this.searchList = res.data.message.data
              this.searchListDefault = this.searchList.find((e, i) => {
                return i === 0
              })
            })
            .catch((error) => {
              this.$gf.httpErrorHandler(error)
            })
        }, 1000)
      }
    },

    search() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#searchBtn',
        scale: 0.45
      })

      this.page = 1
      this.initTable()
    },

    handleDownload() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          'No',
          'Imei',
          'Plate',
          'Device Name',
          'Driver Name',
          'Starting Points',
          'Violation Points',
          'Remaining Points',
          'Driver Category',
          'Month',
          'Year'
        ]
        const filterVal = [
          'no',
          'imei',
          'plate',
          'device_name',
          'driver_name',
          'start_point',
          'violation_point',
          'remaining_point',
          'driver_category',
          'month',
          'year'
        ]

        const list = this.data
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: `${this.filename}_${this.filter.month}`,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
      })
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    },

    handleDownloadDetail() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtnDetail',
        scale: 0.45
      })

      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = ['No', 'Alert Name', 'Point', 'Time', 'Lon', 'Lat']
        const filterVal = ['no', 'alert_name', 'point', 'time', 'lon', 'lat']

        const list = this.data_detail
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: `${this.filenameDetail}_${this.data_detail[0]._gps.plate}_${this.data_detail[0].driver_name}_${this.filter.month}`,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.$vs.loading.close(`#exportBtnDetail > .con-vs-loading`)
      })
    }
  }
}
</script>
